import { zFilteredStringArray } from '@utils/zodv4.util';
import { z } from 'zod/v4';

export const adminOrganizationSlugSchema = z.object({
  slug: z
    .string()
    .max(100, { message: 'Slug must be 100 characters or less.' })
    .regex(/^[a-z0-9_-]*$/, {
      message: 'Slug must contain only lowercase letters, numbers, hyphens, and underscores.',
    }),
});

export const adminOrganizationTagsSchema = z.object({
  selectedTagNames: zFilteredStringArray(z.array(z.string())),
});

export const adminOrganizationHierarchySchema = z.object({
  childOrganizationIds: zFilteredStringArray(z.array(z.uuid({ message: 'Please select valid child organizations.' }))),
  draftIsParentOrganization: z.boolean(),
  draftParentOrganizationIds: z
    .array(z.uuid({ message: 'Please select valid parent organizations.' }))
    .max(1, { message: 'Please select only one parent organization.' }),
});

export type AdminOrganizationHierarchySchema = z.infer<typeof adminOrganizationHierarchySchema>;
export type AdminOrganizationSlugSchema = z.infer<typeof adminOrganizationSlugSchema>;
export type AdminOrganizationTagsSchema = z.infer<typeof adminOrganizationTagsSchema>;
